import { render, staticRenderFns } from "./PlanFilter.vue?vue&type=template&id=5645b3e3&scoped=true&"
import script from "./PlanFilter.vue?vue&type=script&lang=ts&"
export * from "./PlanFilter.vue?vue&type=script&lang=ts&"
import style0 from "./PlanFilter.vue?vue&type=style&index=0&id=5645b3e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645b3e3",
  null
  
)

export default component.exports